import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    alignSelf: 'start',
    marginTop: 10,
    overflowY: 'auto',
    zIndex: 4,
    scrollbarWidth: 'none' /* Firefox */,
    msOverflowStyle: 'none' /* IE and Edge */,
    '&::-webkit-scrollbar': {
      display: 'none' /* Chrome, Safari, Opera */
    }
  },
  filtersContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    flex: 5,
    borderRadius: 8,
    background: theme.palette.grey[100],
    marginTop: 4
  },
  filterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  reset: {
    color: theme.palette.info.main,
    fontWeight: 500
  },
  seprator: {
    width: '100%',
    height: '1px',
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.grey[300],
    marginTop: 10,
    marginBottom: 10
  },
  search: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 6,
    marginBottom: 6
  },
  searchicon: { color: theme.palette.grey[500] },
  input: {
    padding: '12px 14px'
  },
  sarchinput: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        border: 'none'
      }
    }
  },

  filterText: { fontWeight: 600, color: theme.palette.grey[800] },
  starRatingContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 15
  },
  ratingForm: { marginTop: 10 },
  checkbox: {
    padding: 5
  },
  starRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  check: { marginRight: 4 }
}))
export default useStyles
